<template>
  <b-row class="match-height joint">
    <b-col cols="12">
      <b-row>
        <b-col>
          <b-form-checkbox
            v-model="displayPages"
            switch
            class="d-flex justify-content-center"
          >
            Show Pages
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="(projectId, i) in projects"
          :key="`joint-project-${projectId}`"
          class="col-12 col-md-3 mt-1"
        >
          <b-row>
            <b-col
              class="col-12"
            >
              <card-analytic-joint-total-users
                title="Active Users"
                :data-object="getMainQuery(i+1)"
                :on-progress="getMainQueryOnProgress(i+1)"
                :project-id="projectId"
              />
            </b-col>
            <b-col
              v-if="displayPages"
              cols="12"
            >
              <joint-page-view-table
                :page-views="getMainQuery(i+1)"
                :on-progress="getMainQueryOnProgress(i+1)"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
    BRow,
    BCol,
    BFormCheckbox,
} from 'bootstrap-vue'

import CardAnalyticJointTotalUsers from '@/views/card/joint/CardAnalyticJointTotalUsers.vue'
import { executeQuery, resetQueries } from '@/coreApi/coreApiDataset'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { getCoreApiData, getCoreApiDataOnProgress } from '@/coreApi/coreApi'
import { getProjectCoreProjectIdById, getProjectFilterObject } from '@/coreApi/filters/coreApiFilterHelper'
import JointPageViewTable from '@/views/card/joint/JointPageViewTable.vue'
import { getCurrentAccountData } from '@/auth/utils'

export default {
    components: {
        BFormCheckbox,
        JointPageViewTable,
        BRow,
        BCol,
        CardAnalyticJointTotalUsers,
    },
    data() {
        const projects = []
        const allowedProjects = [
            'bl1767ftdlk224',
            'bl2ok5med65lk2',
            'bl8372p22-cn',
            'bl8372p22-ps',
            'bl8372p22-fn',
            'bl8372p22-kd',
            'bl8372p22-tv',
            'bl8372p22-gv',
            'bl8372p22-ma',
            'bl8372p22-ign',
            'bl8372p22-rd',
            'bl8372p22-hdn',
            'bl2ok5med65lk2-mo',
            'bl2ok5med65lk2-muo',
            'bl1767ftdlk224-ho',
            'bl1767ftdlk224-hbo',
        ]
        const userAccounts = getCurrentAccountData()
        if (userAccounts.userProjects) {
            const userProjects = Object.values(userAccounts.userProjects).map(obj => getProjectCoreProjectIdById(obj.projectId))
            userProjects.forEach(userProjectId => {
                if (allowedProjects.includes(userProjectId)) {
                    projects.push(userProjectId)
                }
            })
        }

        return {
            filter: null,
            apexRender: 0,
            byContentFilter: true,
            displayPages: false,
            projects,
            queryTimeoutList: [],
        }
    },
    watch: {
        $route() {
            this.initQueries()
        },
    },
    created() {
        this.initQueries()
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768
        },
        sleep(milliseconds) {
            const start = new Date().getTime()
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < 1e7; i++) {
                if ((new Date().getTime() - start) > milliseconds) {
                    break
                }
            }
        },
        initQueries() {
            const projectFilterObject = getProjectFilterObject()
            const pageFilter = projectFilterObject.getFilterQueryObject()
            pageFilter.push({
                key: 'fromAtSecond',
                value: 300,
            })

            this.projects.forEach((projectId, index) => {
                const pageFilter2 = [...pageFilter]
                this.queryTimeoutList[index] = setTimeout(() => {
                    this.query(`d${index + 1}`, projectId, pageFilter2)
                }, 2000 * (index + 1))
            })
        },
        getFilterObject() {
            const projectFilterObject = getProjectFilterObject()
            return projectFilterObject.getFilterList()
        },
        query(id, projectId, pageFilter) {
            // !!!----- OLD VERSION / NOT IN USE --> Platinum Data Active Users Statistics b1dac0e3a5ef4e8 -----!!! //
            // Platinum Data Active Users Statistics V2 n53221a99c4c3

            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }

            if (projectId === 'bl8372p22-hs') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.hurriyet.com.tr',
                })
            } else if (projectId === 'bl8372p22-ms') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.milliyet.com.tr',
                })
            } else if (projectId === 'bl8372p22-cns') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-cn',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.cnnturk.com',
                })
            } else if (projectId === 'bl8372p22-psts') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-ps',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.posta.com.tr',
                })
            } else if (projectId === 'bl8372p22-gvs') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-gv',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.gazetevatan.com',
                })
            } else if (projectId === 'bl1767ftdlk224-ho') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.hurriyet.com.tr',
                })
            } else if (projectId === 'bl1767ftdlk224-hbo') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'bigpara.hurriyet.com.tr,mbigpara.hurriyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-mo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.milliyet.com.tr,m.milliyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-muo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'uzmanpara.milliyet.com.tr,uzmanparam.milliyet.com.tr',
                })
            } else {
                pageFilter.push({
                    key: 'projectId',
                    value: projectId,
                })
            }

            executeQuery(
                coreApiDataIndex[id],
                {
                    timeout: 22,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'livePageViewStatistics',
                            options: [
                                {
                                    alias: 'livePageViewStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pvFiltered',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pageViewFilter30Min',
                                    filter_values: pageFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'livePageViewDetails',
                            options: [
                                {
                                    alias: 'livePageViewDetails',
                                    return_id: 'pageViews',
                                    offset: 0,
                                    limit: 200,
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pvFiltered',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pageViewFilter30Min',
                                    filter_values: pageFilter,
                                },
                            ],
                        },
                    ],

                },
                22000,
            )
        },
        getMainQuery(index) {
            return this[`mainQueryD${index}`]
        },
        getMainQueryOnProgress(index) {
            return this[`mainQueryOnProgressD${index}`]
        },
    },
    setup() {
        return {
            mainQueryD1: getCoreApiData(coreApiDataIndex.d1),
            mainQueryOnProgressD1: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            mainQueryD2: getCoreApiData(coreApiDataIndex.d2),
            mainQueryOnProgressD2: getCoreApiDataOnProgress(coreApiDataIndex.d2),
            mainQueryD3: getCoreApiData(coreApiDataIndex.d3),
            mainQueryOnProgressD3: getCoreApiDataOnProgress(coreApiDataIndex.d3),
            mainQueryD4: getCoreApiData(coreApiDataIndex.d4),
            mainQueryOnProgressD4: getCoreApiDataOnProgress(coreApiDataIndex.d4),
            mainQueryD5: getCoreApiData(coreApiDataIndex.d5),
            mainQueryOnProgressD5: getCoreApiDataOnProgress(coreApiDataIndex.d5),
            mainQueryD6: getCoreApiData(coreApiDataIndex.d6),
            mainQueryOnProgressD6: getCoreApiDataOnProgress(coreApiDataIndex.d6),
            mainQueryD7: getCoreApiData(coreApiDataIndex.d7),
            mainQueryOnProgressD7: getCoreApiDataOnProgress(coreApiDataIndex.d7),
            mainQueryD8: getCoreApiData(coreApiDataIndex.d8),
            mainQueryOnProgressD8: getCoreApiDataOnProgress(coreApiDataIndex.d8),
            mainQueryD9: getCoreApiData(coreApiDataIndex.d9),
            mainQueryOnProgressD9: getCoreApiDataOnProgress(coreApiDataIndex.d9),
            mainQueryD10: getCoreApiData(coreApiDataIndex.d10),
            mainQueryOnProgressD10: getCoreApiDataOnProgress(coreApiDataIndex.d10),
            mainQueryD11: getCoreApiData(coreApiDataIndex.d11),
            mainQueryOnProgressD11: getCoreApiDataOnProgress(coreApiDataIndex.d11),
            mainQueryD12: getCoreApiData(coreApiDataIndex.d12),
            mainQueryOnProgressD12: getCoreApiDataOnProgress(coreApiDataIndex.d12),
            mainQueryD13: getCoreApiData(coreApiDataIndex.d13),
            mainQueryOnProgressD13: getCoreApiDataOnProgress(coreApiDataIndex.d13),
            mainQueryD14: getCoreApiData(coreApiDataIndex.d14),
            mainQueryOnProgressD14: getCoreApiDataOnProgress(coreApiDataIndex.d14),
            mainQueryD15: getCoreApiData(coreApiDataIndex.d15),
            mainQueryOnProgressD15: getCoreApiDataOnProgress(coreApiDataIndex.d15),
            mainQueryD16: getCoreApiData(coreApiDataIndex.d16),
            mainQueryOnProgressD16: getCoreApiDataOnProgress(coreApiDataIndex.d16),
            mainQueryD17: getCoreApiData(coreApiDataIndex.d17),
            mainQueryOnProgressD17: getCoreApiDataOnProgress(coreApiDataIndex.d17),
            mainQueryD18: getCoreApiData(coreApiDataIndex.d18),
            mainQueryOnProgressD18: getCoreApiDataOnProgress(coreApiDataIndex.d18),
            mainQueryD19: getCoreApiData(coreApiDataIndex.d19),
            mainQueryOnProgressD19: getCoreApiDataOnProgress(coreApiDataIndex.d19),
            mainQueryD20: getCoreApiData(coreApiDataIndex.d20),
            mainQueryOnProgressD20: getCoreApiDataOnProgress(coreApiDataIndex.d20),
            mainQueryD21: getCoreApiData(coreApiDataIndex.d21),
            mainQueryOnProgressD21: getCoreApiDataOnProgress(coreApiDataIndex.d21),
            mainQueryD22: getCoreApiData(coreApiDataIndex.d22),
            mainQueryOnProgressD22: getCoreApiDataOnProgress(coreApiDataIndex.d22),
            mainQueryD23: getCoreApiData(coreApiDataIndex.d23),
            mainQueryOnProgressD23: getCoreApiDataOnProgress(coreApiDataIndex.d23),
            mainQueryD24: getCoreApiData(coreApiDataIndex.d24),
            mainQueryOnProgressD24: getCoreApiDataOnProgress(coreApiDataIndex.d24),
            mainQueryD25: getCoreApiData(coreApiDataIndex.d25),
            mainQueryOnProgressD25: getCoreApiDataOnProgress(coreApiDataIndex.d25),
        }
    },
    beforeRouteLeave(to, from, next) {
        this.queryTimeoutList.forEach(timeoutId => {
            clearTimeout(timeoutId)
        })
        resetQueries()
        next()
    },
}
</script>

<style>

</style>
